import { IconSparkles } from "@tabler/icons-react";
import "@assets/css/common/thinkingAnimation.css";

function ThinkingAnimation({ label = "Thinking..." }) {
  return (
    <div className="app-thinking-animation" role="status" aria-live="polite">
      <span className="app-thinking-animation-icon" aria-hidden="true">
        <IconSparkles size={22} />
      </span>
      <span>{label}</span>
      <span className="app-thinking-animation-dots" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
    </div>
  );
}

export default ThinkingAnimation;
